import { PipeTransform, Pipe } from "@angular/core";
import * as moment from 'moment';

@Pipe({
  name: 'localDateTimePipe3'
})
export class LocalDateTimePipe3 implements PipeTransform {
  transform(time: number): string {
    let data = new Date(time);
    const formattedDate = data.toLocaleDateString('pt-BR');
    // let dataFormatada = data.getFullYear()+'-'+data.getMonth()+'-'+data.getDate();
    // let dateOut: moment.Moment = moment(dataFormatada, "YYYY-MM-DD");
    // return dateOut.format("DD/MM/YYYY");
    return formattedDate;
}
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/listar-conteudos/local-date-conteudo.ts